import { render } from "./reports.vue?vue&type=template&id=40cf0ed8"
import script from "./reports.vue?vue&type=script&lang=js"
export * from "./reports.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__